import type { RecommendationDto } from '@ederest/contracts';
import { displayFieldLabel } from '../../shared/ui/field-label.js';

/**
 * The priority is the friction weighted by what users said (functional §5.5:
 * friction × demand ÷ 100). The demand comes from the "Non" answers collected
 * on the page, so without any the priority is zero whatever the friction — the
 * Console then says so instead of printing a 0 that reads as "not important".
 */
export const PRIORITY_HINT =
  "Ordre de traitement conseillé, de 0 à 100 : la friction mesurée, pondérée par les avis négatifs des usagers sur la page. « Sans avis » : aucun avis négatif recueilli, la priorité n'est pas calculée et seule la friction compte.";

export function isPriorityKnown(recommendation: RecommendationDto): boolean {
  return recommendation.priorityScore > 0;
}

/** A label the page wrote in Arabic must not reorder the French sentence around it (first-strong isolate). */
export const isolate = (text: string) => `⁨${text}⁩`;

/** Where the difficulty sits, in the words of the page: the field when there is one, otherwise the whole step. */
export function targetOf(recommendation: RecommendationDto): string {
  const { fieldKey, fieldLabel } = recommendation.evidence;
  if (!fieldKey) return "Toute l'étape";
  return `Champ « ${isolate(displayFieldLabel(fieldLabel, fieldKey))} »`;
}
